export const DEFAULT_LOCALE = "en";
export const COOKIE_CONSENT_COOKIE = "cookie-consent";